/**
 * Default tooltip configurations for charts
 */

export const DEFAULT_TOOLTIP = {
  visible: true,
  trigger: 'hover',
  enterable: true, // Allow mouse to enter tooltip
  padding: 8,
  style: {
    fontWeight: 'normal',
    fontSize: 12,
    backgroundColor: 'rgba(50, 50, 50, 0.9)',
    color: '#fff'
  }
};

// Tooltip formatters for different chart types
export const TOOLTIP_FORMATTERS = {
  // Default formatter that shows field name and value
  default: (datum) => {
    const entries = Object.entries(datum)
      .filter(([key]) => !key.startsWith('_') && key !== 'id')
      .map(([key, value]) => `${key}: ${value}`);
      
    return entries.join('<br />');
  },
  
  // Custom formatters for specific chart types
  bar: (datum) => {
    // Custom formatter for bar charts
    return `${datum.name || datum.x}: ${datum.value || datum.y}`;
  },
  
  pie: (datum) => {
    // Custom formatter for pie charts
    return `${datum.name}: ${datum.value} (${datum.percentage}%)`;
  }
}; 